import deMessages from 'ra-language-german';

const de = {
    ...deMessages,
    resources: {
        events: {
            name: 'Veranstaltung |||| Veranstaltungen',
            fields: {
                title: 'Titel',
                category: 'Kategorie',
                country_id: 'Land',
                region_id: 'Region',
                start_at: 'Startzeit',
                end_at: 'Endzeit',
                online: 'Online',
                on_site: 'Vor Ort',
                lat: 'Breitengrad',
                lng: 'Längengrad',
                address: 'Adresse',
                organization_name: 'Organisation Name',
                organization_website: 'Organisation Webseite',
                organization_contact_info: 'Organisation Kontaktinformationen',
                intro: 'Einführung',
                content: 'Inhalt',
                status: 'Status',
                published: 'Veröffentlicht'
            }
        },
        account: {
            fields: {
                firstname: 'Vorname',
                lastname: 'Nachname',
                password: 'Passwort',
                job_title: 'Berufsbezeichnung',
                organization_name: 'Organisation Name',
                organization_address: 'Organisation Adresse',
                organization_website: 'Organisation Webseite',
                organization_contact_name: 'Name Kontakt Organisation',
                organization_contact_email: 'E-Mail Kontakt Organisation',
            }
        }
    },
    'Total': 'Insgesamt',
    'My upcoming event(s)': 'Meine bevorstehende(n) Veranstaltung(en)',
    'Join us and create an event': 'Werden Sie Mitglied und erstellen Sie eine Veranstaltung',
    'Once your event is created the Europe Members team will review your event. If everything is in order, you will be prompted by e-mail and you will be able to publish your event.': 'Sobald Ihre Veranstaltung erstellt ist, wird das Europe Remembers Team Ihre Veranstaltung überprüfen. Wenn alles in Ordnung ist, werden Sie per E-Mail benachrichtigt und können Ihre Veranstaltung veröffentlichen.',
    'Create event': 'Veranstaltung erstellen',
    'Search': 'Suche',
    'Country': 'Land',
    'Region': 'Region',
    'Published': 'Veröffentlicht',
    'Online': 'Online',
    'On site': 'Vor Ort',
    'Draft': 'Entwurf',
    'Review': 'Überprüfung',
    'Accepted': 'Akzeptiert',
    'Refused': 'Abgelehnt',
    'Commemoration': 'Gedenken',
    'Conference': 'Konferenz',
    'Festival': 'Festival',
    'Guided tour': 'Geführter Rundgang',
    'Exhibition': 'Ausstellung',
    'Music-Theater': 'Musik-Theater',
    'Other': 'Andere',
    'Ask for review': 'Überprüfung anfordern',
    'Do you want to ask a review for the event': 'Möchten Sie eine Überprüfung für die Veranstaltung anfordern?',
    'Unpublish': 'Veröffentlichung aufheben',
    'Do you want to unpublish the event': 'Möchten Sie die Veranstaltung nicht mehr veröffentlichen?',
    'Event published': 'Veranstaltung veröffentlicht',
    'Event unpublished': 'Veranstaltung nicht mehr veröffentlicht',
    'Publish': 'Veröffentlichen',
    'Do you want to publish the event': 'Möchten Sie die Veranstaltung veröffentlichen?',
    'Summary': 'Zusammenfassung',
    'Translations': 'Übersetzungen',
    'Pictures': 'Bilder',
    'Title': 'Titel',
    'Intro': 'Einführung',
    'Content': 'Inhalt',
    'Picture': 'Bild',
    'Description': 'Beschreibung',
    'Copyright': 'Urheberrecht',
    'Featured': 'Vorgestellt',
    'Account': 'Konto',
    'Account updated': 'Konto aktualisiert',
    'Forgot password?': 'Passwort vergessen?',
    'Forgot password': 'Passwort vergessen',
    'An email has been sent': 'Eine E-Mail wurde gesendet',
    'Email': 'E-Mail',
    'Reset password': 'Passwort zurücksetzen',
    'Main picture': 'Hauptbild',
    'Default language': 'Standardsprache',
    'Event website': 'Website der Veranstaltung',
    'Europe Remembers : How to create an event ?': 'Europe Remembers : Wie kann man eine Veranstaltung organisieren?',
    'Turn on subtitles (CC) to get instructions in your language.': 'Schalten Sie Untertitel (CC) ein, um Anweisungen in Ihrer Sprache zu erhalten.',
    'Contribute to the project!': 'Leisten Sie \neinen Beitrag!',
    'Europe Remembers aims to give visibility to your events and is free to use ! However we need your contributions to help us maintain and keep this platform running.': 'Europe Remembers soll Ihre Veranstaltungen sichtbar machen und kann kostenlos genutzt werden! Wir sind jedoch auf Ihre Beiträge angewiesen, um diese Plattform zu pflegen und am Laufen zu halten.'
};

export default de;